export default {
    addresses: {
        title: "Enter delivery information",
        fullName: {
            label: "Full Name",
            placeholder: "Enter Full Name"
        },
        firstName: {
            label: "First Name",
            placeholder: "Enter First Name"
        },
        lastName: {
            label: "Last Name",
            placeholder: "Enter Last Name"
        },
        phone: {
            label: "Phone number",
            placeholder: "Enter phone number"
        },
        number: {
            label: "Street number",
            placeholder: "Enter street number"
        },
        city: {
            label: "City",
            placeholder: "Choose City"
        },
        address: {
            label: "Address",
            placeholder: "Enter address",
            addNew: "Add new address",
            chooseAnother: "Choose another address",
            viewAll: "View all addresses"
        },
        primaryAddress: "Use this address as your primary address.",
        backOnCartLink: "Back on Cart",
        buttonApproval: "Approval",
        saveAddress: "Save Address"
    },
    chooseAddress: {
        title: "Enter delivery information",
        chooseAddress: 'Choose address:',
        addNewAddress: "Add new address",
        backOnCartLink: "Back on Cart",
        buttonPayment: "Payment",
        addressCard: {
            button: {
                edit: "Edit",
                primaryAddress: "Primary address",
                setPrimary: "Set as parimary address"
            }
        }
    },
    payment: {
        title: "Payment method",
        byCard: "By credit card",
        byCashOnDelivery: "By cash on delivery",
        cvvInfo: 'The CVV number is a 3 or 4 digit security code, usually located on the back of your card.',
        infoMsg: "The amount to be removed from your card is shown in your Online Payment bill.",
        cardInfo: {
            title: "Credit card information",
            form: {
                firstName: {
                    label: "First name",
                    placeholder: "Enter first name"
                },
                lastName: {
                    label: "Last name",
                    placeholder: "Enter last name"
                },
                cardNumber: {
                    label: "Credit card number",
                    placeholder: "0000 0000 0000 0000"
                },
                validThru: {
                    label: "Valid thru",
                    placeholder: "MM / YY"
                },
                cvv: {
                    label: "CVV",
                    placeholder: "000"
                },
            }
        },
        cashOnDelivery: {
            infoMsg: `Certain products do not have the option to pay by cash on delivery so they cannot be purchased.
                    These products have been removed from the order and shown in the list below.
                    Changing your payment method may return these products to your order.`,
            removedProducts: 'Removed products',
            footerInfoMsg: 'Products from this list have been removed from the order because they do not have the option to pay by cash on delivery.'
        },
        checkbox: {
            option1: "Save card information for future purchases",
            option2: "The billing address is the same as the shipping address"
        },
        navigation: {
            back: "Delivery",
            forward: "Approval",
            backOnCart: "Back on Cart"
        },
        validationErrors: {
            'number_errors_blank': 'Card number must not be empty.',
            'cvv_errors_blank': 'CVV code must not be empty.',
            'number_errors_invalid': 'Invalid card number.',
            'cvv_errors_invalid': 'Invalid CVV code.',
            'validThru_errors_blank': 'Expiration date must not be empty.',
            'validThru_errors_invalid': 'Invalid expiration date.',
            'validThru_errors_expired': 'Card expired.',
            'first_name_errors_blank': 'First name must not be empty.',
            'last_name_errors_blank': 'Last name must not be empty.',
        }
    },
    approval: {
        title: "Order approval",
        subtitle: {
            deliveryInformation: "Delivery information",
            orderPreview: "Order preview"
        },
        payment: {
            title: "Payment method",
            creditCard: "Credit Card",
            cashOnDelivery: "Cash on delivery",
            creditCardPayment: 'The amount to be paid by card:',
            cashOnDeliveryPayment: 'Amount payable by cash on delivery:'
        },
        storeDelivery: 'Products supplied by the store',
        sellsAndGuarantees: 'sells and guarantees',
        forProducts: 'for products.',
        note: "Note",
        addNote: "Add Note",
        delivery: "Store charges delivery",
        notePlaceholder: "Leave a note to the seller",
        navigation: {
            back: "Payment",
            forward: "Confirm the order",
            backOnCart: "Back on Cart"
        },
    },
    pay: 'Pay'
}
